import { useQuery } from "@tanstack/react-query";
import { getStockPoliciesApi } from "../api/stockPoliciesApi";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const useGetStockPoliciesQuery = (chainId: ChainId | null) => {
  return useQuery({
    queryKey: ["chains", chainId, "stockPolicies"],
    queryFn: () => getStockPoliciesApi(chainId!),
    enabled: !!chainId,
  });
};
